import classNames from 'classnames'
import {
  TrustpilotStar,
  TrustpilotStarColor,
} from 'components/common/TrustpilotStar'
import { PropsWithClassName } from 'types'
import { range } from 'utils/arrays'

interface Props extends PropsWithClassName {
  count?: number
  itemClass?: string
  iconSize?: number
  iconColor?: TrustpilotStarColor
}

export function TrustpilotStars({
  className,
  count = 5,
  itemClass,
  iconSize,
  iconColor,
}: Props) {
  return (
    <div
      className={classNames(
        className,
        'flex items-center justify-center space-x-0.5'
      )}
    >
      {range(0, count).map(i => (
        <TrustpilotStar
          key={i}
          className={itemClass}
          iconSize={iconSize}
          color={iconColor}
        />
      ))}
    </div>
  )
}
